import { render, staticRenderFns } from "./ClientsSelect.vue?vue&type=template&id=0462ec40&scoped=true&"
import script from "./ClientsSelect.vue?vue&type=script&lang=js&"
export * from "./ClientsSelect.vue?vue&type=script&lang=js&"
import style0 from "./ClientsSelect.vue?vue&type=style&index=0&id=0462ec40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0462ec40",
  null
  
)

export default component.exports